<template>
  <Card
    title="Recommended Video"
  >
    <template v-slot:button>
      <Button variant="primary" label="Save" @clicked="save" />
    </template>
    <template v-slot:body>
      <form-item label="Video Name">
        <template v-slot:default>
          <el-select
            v-model="videoId"
            filterable
            remote
            default-first-option
            placeholder="Select Video"
            :remote-method="searchVideos"
            :loading="loading"
            class="w-full">
            <el-option
              v-for="item in videoList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </form-item>
    </template>
  </Card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Card from '@/components/Layout/Card';
import { Button, FormItem } from '@/components/Layout/Form';

export default {
  name: 'RecommendedVideosPage',
  data() {
    return {
      videoId: null,
      videoList: [],
      loading: false,
    };
  },
  async mounted() {
    await this.loadInit();
  },
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
  },
  methods: {
    ...mapActions('MissionsVideosModule', ['requestGetRecommendedVideos', 'requestSearchVideos', 'requestSetRecommendedVideos']),
    async loadInit() {
      const data = await this.requestGetRecommendedVideos();
      if (data) {
        this.videoList = [{
          value: data.id,
          label: `${data.name}`,
        }];
        this.videoId = data.id;
      }
    },
    async searchVideos(query) {
      if (query !== '') {
        this.loading = true;
        const tags = await this.requestSearchVideos({ q: query, per_page: 20 });
        this.loading = false;
        this.videoList = tags.map(item => ({ value: item.id, label: `${item.name}` }));
      } else {
        this.videoList = [];
      }
    },
    async save() {
      if (this.videoId) {
        await this.requestSetRecommendedVideos({
          id: this.videoId,
        });
        if (this.getStatus === 200) {
          await this.loadInit();
          this.$swal('Recommended Video Saved', '', 'success');
        } else if (this.getStatus === 400 && this.getErrorCode === 'error-set-recom-videos') {
          this.$swal('Error', this.getMessage, 'error');
        }
      } else {
        this.$swal('Error', 'Video cannot be empty', 'error');
      }
    },
  },
  components: { Card, Button, FormItem },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/MissionsVideos/Videos/RecommendedVideos.vue